import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, jump the window to top INSTANTLY (no smooth
 * animation), so a new page never appears to "scroll up" to itself.
 * Mounted once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Suspend smooth-scroll for this one jump, then restore.
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    requestAnimationFrame(() => {
      html.style.scrollBehavior = prev || "";
    });

    // Google Analytics SPA pageview tracking
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + window.location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname]);

  return null;
}
